import { Link } from "react-router-dom";
import { ArrowRight, Wrench } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";

export const CTASection = () => (
  <section data-testid="cta-section" className="relative overflow-hidden border-t border-white/10 py-28 md:py-40">
    <div className="blueprint-grid absolute inset-0 opacity-40" />
    <div className="absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-blue/10 blur-[120px]" />
    <div className="relative mx-auto max-w-[1440px] px-6 text-center md:px-12">
      <Reveal>
        <h2 className="mx-auto max-w-4xl font-display text-4xl font-extrabold leading-[1] tracking-tight md:text-6xl">
          Your HVAC system should be engineered to work — <span className="text-slatex-300">not hoped into working.</span>
        </h2>
        <p className="mx-auto mt-7 max-w-2xl font-body text-base leading-relaxed text-slatex-300 md:text-lg">
          Precision diagnostics, professional service, and clean installation for residential and light commercial HVAC systems.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <Link to="/contact" data-testid="cta-request-service" className="group flex items-center gap-2 border border-brand-cyan bg-brand-cyan px-8 py-4 font-mono text-xs uppercase tracking-widest text-ink transition-colors hover:bg-brand-cyan/85">
            Request Service <ArrowRight size={15} weight="bold" className="transition-transform group-hover:translate-x-1" />
          </Link>
          <Link to="/contact" data-testid="cta-installation-quote" className="group flex items-center gap-2 border border-white/20 px-8 py-4 font-mono text-xs uppercase tracking-widest text-white transition-colors hover:border-white/50 hover:bg-white/5">
            <Wrench size={15} /> Get an Installation Quote
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTASection;
